function Welcome() {
  return (
    <section className="pt-4 pt-md-11">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-5 col-lg-6 order-md-2">
            <img
              src="https://storage.googleapis.com/kegow-public/kegow-wallet-users.jpeg"
              className="img-fluid rounded mw-md-150 mw-lg-130 mb-6 mb-md-0"
              alt="Women using Kegow wallet"
              data-aos="fade-up"
              data-aos-delay="100"
            />
          </div>
          <div
            className="col-12 col-md-7 col-lg-6 order-md-1"
            data-aos="fade-up"
          >
            <h1 className="display-3 text-center text-md-start">
              Thrive with <span className="text-primary">Kegow</span>. <br />
              Fast and seamless mobile payments.
            </h1>

            <p className="lead text-center text-md-start text-muted mb-6 mb-lg-8">
              Kegow empowers you to earn more, putting seamless, fast,
              comfortable digital payments and withdrawals at your reach.
            </p>

            <div className="text-center text-md-start">
              <a href="/signup" className="btn btn-primary shadow lift me-3">
                Get started
                <i className="fe fe-arrow-right d-none d-md-inline ms-3"></i>
              </a>
              <a href="/login" className="btn btn-primary-soft lift">
                Login
              </a>
            </div>
          </div>
        </div>{" "}
      </div>
    </section>
  );
}

export default Welcome;
